import { gql } from '@apollo/client';

export const fetchInvoiceGroupQuery = gql`
  query fetchInvoiceGroup($id: ID!) {
    invoiceGroup(id: $id) {
      id
      name
      currency
      updatePaymentMethodLink
      transactionAccountId
      transactionAccountNumber
      shipToParty {
        id
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        shipToPriceEligibility
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
        taxExempt
      }
      defaultPaymentMethod {
        id
        type
        default
        paymentIssue
        # 'ID' and this fragment are not being used but added because of BillingV2 graph generation need
        ... on CreditCard {
          card {
            expirationMonth
            expirationYear
            last4Numbers
            brand
            cardHolderName
          }
        }
      }
      transactionAccount {
        id
        displayName
        updatePaymentMethodLink
        availablePaymentMethods {
          totalCount
          nodes {
            id
            paymentIssue
            type
            default
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
                cardHolderName
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
        }
      }
      recipients
      purchaseOrder {
        number
        oneTimeUse
      }
    }
  }
`;
